import styled from "styled-components";
const AlertsPageDisplay = styled.div`
	// my css here
`;	export default AlertsPageDisplay;
